import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { DragIcon } from '@systemeio/ui/icons';
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
interface ItemWrapperProps extends PropsWithChildren {
  id: number | string;
  iconClassName?: string;
  className?: string;
}
const ItemWrapper = t0 => {
  const $ = _c(22);
  const {
    children,
    id,
    iconClassName,
    className
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = {
      id,
      animateLayoutChanges
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transition,
    transform
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 0.5 : undefined;
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== transition) {
    t4 = {
      transition,
      transform: t2,
      opacity: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = transition;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const style = t4;
  let t5;
  if ($[8] !== className) {
    t5 = twMerge("flex cursor-grab items-center gap-3", className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== iconClassName) {
    t6 = twMerge("shrink-0", iconClassName);
    $[10] = iconClassName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <DragIcon className={t6} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== attributes || $[15] !== children || $[16] !== listeners || $[17] !== setNodeRef || $[18] !== style || $[19] !== t5 || $[20] !== t7) {
    t8 = <div className={t5} ref={setNodeRef} style={style} {...attributes} {...listeners}>{t7}{children}</div>;
    $[14] = attributes;
    $[15] = children;
    $[16] = listeners;
    $[17] = setNodeRef;
    $[18] = style;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default ItemWrapper;